import { render } from "./ButtonOne.vue?vue&type=template&id=1d2d470d&scoped=true"
import script from "./ButtonOne.vue?vue&type=script&lang=js"
export * from "./ButtonOne.vue?vue&type=script&lang=js"

import "./ButtonOne.vue?vue&type=style&index=0&id=1d2d470d&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2d470d"]])

export default __exports__